<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper content-wrapper-exemption">
            <div class="img-desktop img-desktop-create d-lg-inline-block"></div>

            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-10 form-request-content-large">
                            <div class="request-title">
                                <h1>Contactez nous</h1>
                            </div>

                            <div class="required-field-text">Champs obligatoires</div>
                            <div class="form-group">
                                <form
                                        name="exemption"
                                        method="post"
                                        enctype="multipart/form-data"
                                        novalidate="novalidate"
                                        class="needs-validation"
                                >
                                    <!-- FirstName -->
                                    <label class="required-field-asterisks required"
                                           for="firstName"
                                    >Prénom</label>
                                    <input type="text"
                                           id="firstName"
                                           class="form-control form-control-lg"
                                           placeholder="Prénom"
                                           :class="{ 'is-invalid': $v.formData.firstName.$error }"
                                           @input="delayTouch($v.formData.firstName)"
                                           v-model="formData.firstName"
                                    >
                                    <FormError error="Veuillez renseigner l’email"
                                               v-if="!$v.formData.firstName.required && $v.formData.firstName.$dirty"
                                    ></FormError>
                                    <!-- FirstName -->

                                    <!-- LastName -->
                                    <label class="required-field-asterisks required"
                                           for="firstName"
                                    >Nom</label>
                                    <input type="text"
                                           id="lastName"
                                           class="form-control form-control-lg"
                                           placeholder="Nom"
                                           :class="{ 'is-invalid': $v.formData.lastName.$error }"
                                           @input="delayTouch($v.formData.lastName)"
                                           v-model="formData.lastName"
                                    >
                                    <FormError error="Veuillez renseigner l’email"
                                               v-if="!$v.formData.lastName.required && $v.formData.lastName.$dirty"
                                    ></FormError>
                                    <!-- LastName -->

                                    <!-- Email -->
                                    <label class="required-field-asterisks required"
                                           for="email"
                                    >Adresse email</label>
                                    <input type="email"
                                           id="email"
                                           class="form-control form-control-lg"
                                           placeholder="Email"
                                           :class="{ 'is-invalid': $v.formData.email.$error }"
                                           @input="delayTouch($v.formData.email)"
                                           v-model="formData.email"
                                    >
                                    <FormError error="Format de l'email incorrect"
                                               v-if="!$v.formData.email.email && $v.formData.email.$dirty"
                                    ></FormError>
                                    <FormError error="Veuillez renseigner l’email"
                                               v-if="!$v.formData.email.required && $v.formData.email.$dirty"
                                    ></FormError>
                                    <!-- Email -->

                                    <!-- Phone Number -->
                                    <div class="form-group">
                                        <label for="phone">Numéro de téléphone</label>
                                        <div class="input-group" >
                                            <div class="input-group-prepend">
                                                    <span class="input-group-text">
                                                        <i class="fas fa-phone"></i>
                                                    </span>
                                            </div>
                                            <masked-input
                                                    type="tel"
                                                    mask="\+\33 1 11 11 11 11"
                                                    id="phone"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.formData.phoneNumber.$error }"
                                                    @input="delayTouch($v.formData.phoneNumber)"
                                                    v-model="formData.phoneNumber"
                                            />
                                        </div>
                                        <FormError error="Le numéro de téléphone doit contenir 11 chiffres"
                                                   v-if="!$v.formData.phoneNumber.phoneLength && $v.formData.phoneNumber.$dirty"
                                        ></FormError>
                                    </div>
                                    <!-- Phone Number -->

                                    <!-- Message -->
                                    <label for="reject-reason"
                                           class="required-field-asterisks"
                                    >Message</label>
                                    <textarea id="reject-reason"
                                              class="form-control form-control-lg"
                                              :class="{ 'is-invalid': $v.formData.message.$error }"
                                              @input="delayTouch($v.formData.message)"
                                              v-model="formData.message"
                                    ></textarea>
                                    <FormError error="Le numéro de téléphone doit contenir 11 chiffres"
                                               v-if="$v.formData.message.$error"
                                    ></FormError>
                                    <!-- Message -->
                                </form>
                            </div>
                        </div>

                        <div class="input-group col-md-10 mx-sm-auto my-md-4">
                            <div class="mx-sm-auto">
                                <button class="btn btn-success btn-lg ml-4 btn-link btn__save"
                                        :disabled="$v.$invalid || isLoading"
                                        @click.prevent="send"
                                >
                                    <span>Confirmer ma demande</span>
                                    <ButtonSpinner :isLoading="isLoading"></ButtonSpinner>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '@/components/Sidebar';
    import Footer from '@/components/Footer';
    import MaskedInput from 'vue-masked-input';
    import FormError from '@/components/FormError';
    import ValidationDelayTouch from '@/mixins/validationDelayTouch';
    import ButtonSpinner from '@/components/ButtonSpinner';
    import { email, required } from 'vuelidate/lib/validators';
    import { phoneNumberConstraint } from '@/utils/validation';
    import { createAppContactUs } from '@/service/api/dues.api';

    export default {
        mixins: [ValidationDelayTouch],
        data() {
            return {
                formData: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    message: '',
                    phoneNumber: '',
                },
                isLoading: false
            };
        },
        methods: {
            async send() {
                this.isLoading = true;
                try {
                    await createAppContactUs(this.formData);

                    this.isLoading = false;
                    await this.$router.push({
                        name: 'success',
                        params: { messageShortCode: 'app_contact_us_email' }
                    });
                } catch ({ response }) {
                    this.isLoading = false;
                }
            }
        },
        validations: {
            formData: {
                firstName: {
                    required
                },
                lastName: {
                    required
                },
                email: {
                    required,
                    email
                },
                phoneNumber: {
                    phoneLength: phoneNumberConstraint
                },
                message: {
                    required
                }
            }
        },
        components: {
            Sidebar,
            Footer,
            MaskedInput,
            FormError,
            ButtonSpinner
        }
    }
</script>
